<template>
  <v-card outlined :style="style" :class="classes">
    <v-container class="pt-0">
      <v-row>
        <v-col class="pb-0">
          <h4>Nishika Connect利用規約（求職者向け）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          本Nishika Connect利用規約（求職者向け）（以下「本規約」といいます。）には、Nishika株式会社（以下「当社」といいます。）の提供する本サービス（第2条に定義）のご利用にあたり、求職者（第2条に定義）の皆様に遵守していただかなければならない事項及び当社と求職者の皆様との間の権利義務関係が定められております。本サービスをご利用になる求職者の皆様は、本規約に同意する前に、必ず全文お読み下さいますようお願い致します。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第1条（適用）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本規約は、本サービスの利用に関する当社と求職者との間の権利義務関係を定めることを目的とし、求職者と当社の間の本サービスの利用に関わる一切の関係に適用されます。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第2条（定義）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本規約において使用する以下の用語は各々以下に定める意味を有するものとします。
          <ol>
            <li>「求人企業」とは、本サービスに登録し、求職者の雇用又は業務委託の求人を行う法人を意味します。</li>
            <li>「求職者」とは、第3条に基づき求職者として本サービスに登録された者を意味します。</li>
            <li>「求人情報」とは、求人企業が本サービスにおいて募集する雇用又は業務委託をする人材、契約条件その他の情報を意味します。</li>
            <li>「外部サービス」とは、他の事業者が提供している当社所定のサービスで、本サービスの実施に利用されるサービスを意味します</li>
            <li>「外部事業者」とは、外部サービスのサービス提供者を意味します</li>
            <li>「外部利用規約」とは、求職者と外部事業者との権利関係を定める規約を意味します</li>
            <li>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します</li>
            <li>「当社ウェブサイト」とは、そのドメインが「connect.nishika.com」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します</li>
            <li>「登録希望者」とは、第3条において定義された「登録希望者」を意味します</li>
            <li>「登録情報」とは、第3条において定義された「登録情報」を意味します</li>
            <li>「本サービス」とは、当社が提供するNishika Connectという名称の求人情報掲載サービス（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。</li>
            <li>「利用契約」とは、第3条第4項に定義される「利用契約」を意味します。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第3条（登録）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。</li>
            <li>登録の申請は必ず本サービスを利用する登録希望者自身が行わなければならず、原則として代理人による登録申請は認められません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。</li>
            <li>当社は、第1項に基づき登録を申請した者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります。</li>
              <ol>
                <li>本規約に違反するおそれがあると当社が判断した場合</li>
                <li>当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合</li>
                <li>過去に本サービスの利用の登録を取り消された者である場合</li>
                <li>登録の申請が登録希望者が満15歳に達した日以後の最初の3月31日が終了するまでになされた場合</li>
                <li>未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合</li>
                <li>反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他暴力、威力又は詐欺的手法を使用して経済的利益を追求する集団又は個人を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合</li>
                <li>その他、当社が登録を適当でないと合理的に判断した場合</li>
              </ol>
            <li>当社は、前項その他当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に通知します。かかる通知により登録希望者の求職者としての登録は完了し、本規約の諸規定に従った本サービスの利用にかかる契約（以下「利用契約」といいます。）が求職者と当社の間に成立します。</li>
            <li>求職者は、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第4条（本サービスの利用）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者は、利用契約の有効期間中、本規約に従って、当社の定める方法に従い、本サービスを利用することができます。</li>
            <li>求職者は、本サービスを通じて以下の行為を行うことができます。</li>
              <ol>
                <li>求人情報の閲覧</li>
                <li>求人情報への応募</li>
                <li>前各号に附随関連する本サービス上の機能の利用</li>
              </ol>
            <li>求職者は、真実かつ正確に、当社が指定するプロフィールに関する情報（以下「プロフィール情報」といいます。）及び連絡先（以下「連絡先」といいます。）の登録を行うとともに、その内容に変動が生じた場合には、直ちに、かかる変動に合わせてプロフィール情報及び連絡先の内容を変更するものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第5条（本サービスの利用料金）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          求職者は、本サービスを無料で利用することができるものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第6条（アカウント情報の管理）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者は、自己の責任において、本サービスにかかるユーザーID及びパスワード（以下「アカウント情報」といいます。）を管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。</li>
            <li>アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任は求職者が負うものとし、当社は一切の責任を負いません。</li>
            <li>求職者は、 アカウント情報が盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第7条（個人情報の委託について）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          当社は事業運営上、業務委託先に個人情報の取り扱いを委託することがあります。この場合、当社は、個人情報を適切に保護できる管理体制を敷き実行していることを条件として委託先を厳選したうえで、契約等において個人情報の適正管理・機密保持などにより利用者の個人情報の漏洩防止に必要な事項を取決め、適切な管理を実施させます。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第8条（禁止行為）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。</li>
            <ol>
              <li>当社、求人企業、他の求職者、又は外部事業者その他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含みます。）</li>
              <li>他人になりすまして、又は他人のために本サービスを利用する行為</li>
              <li>継続意思がないにもかかわらず転職祝い金を申請する行為</li>
              <li>就業意思がないにもかかわらず求人情報に対して応募する行為</li>
              <li>登録企業との間での面接の約束を正当な理由なく破る、その他登録企業に対する不誠実な行為</li>
              <li>採用事実の隠蔽など、登録企業の不正（登録企業による当サービスの運営を妨げる恐れのある全ての行為を含みます）に協力する行為</li>
              <li>他の求職者の個人情報、求人企業に関する情報を、当該情報の保有者及び当社に無断で収集し、若しくは本サービスで知った情報を当社に無断で第三者に開示する行為</li>
              <li>営業、宣伝、広告、勧誘、会員の募集等本サービスが本来予定している求職の目的と異なる目的で本サービスを利用する行為（但し、当社が別途認めるものは除きます。）</li>
              <li>犯罪行為に関連する行為又は公序良俗に反する行為</li>
              <li>猥褻な情報又は青少年に有害な情報を送信する行為</li>
              <li>異性交際に関する情報を送信する行為</li>
              <li>法令又は当社若しくは求職者が所属する法人その他の団体の内部規則に違反する行為</li>
              <li>コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為</li>
              <li>当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為</li>
              <li>当社による本サービスの運営を妨害するおそれのあると合理的に認められる行為</li>
              <li>その他、当社が不適切と合理的に判断する行為</li>
            </ol>
            <li>当社は、本サービスにおける求職者による情報（プロフィール情報及び本サービス上のメッセージを含みます。）の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が合理的に判断した場合には、求職者に事前に通知することなく、当該情報の全部又は一部について削除、送信停止その他の措置をとることができるものとします。当社は、本項に基づき当社が行った措置に基づき求職者に生じた損害について一切の責任を負いません。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第9条（本サービスの停止等）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>当社は、以下のいずれかに該当する場合には、求職者に事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとします。</li>
            <ol>
              <li>本サービスに係るコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合</li>
              <li>コンピューター、通信回線等が事故により停止した場合</li>
              <li>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
              <li>外部サービスに、トラブル、サービス提供の中断又は停止、本サービスとの連携の停止、仕様変更等が生じた場合</li>
              <li>その他、当社が停止又は中断を合理的に必要と判断した場合</li>
            </ol>
            <li>当社は、当社の判断により、本サービスの提供を終了することができます。この場合、当社は求職者に事前に通知するものとします。</li>
            <li>当社は、本条に基づき当社が行った措置に基づき求職者に生じた損害について一切の責任を負いません。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第10条（設備の負担等）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>本サービスの提供を受けるために必要な、コンピューター、スマートフォン、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、求職者の費用と責任において行うものとします。</li>
            <li>求職者は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</li>
            <li>当社は、求職者が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。</li>
            <li>求職者は、本サービスの利用開始に際し又は本サービスの利用中に、当社ウェブサイトからのダウンロードその他の方法によりソフトウェア等を求職者のコンピューター、スマートフォン等にインストールする場合には、求職者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第11条（権利帰属）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>当社ウェブサイト及び本サービスに関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本規約に定める登録に基づく本サービスの利用許諾は、本規約において明示されているものを除き、当社ウェブサイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の譲渡又は使用許諾を意味するものではありません。求職者は、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません。）をしないものとします。</li>
            <li>当社は、求職者の本サービスの利用状況等に関するデータ（但し、求職者が特定できない形で匿名化したデータ又は統計データに限ります。）を自由に利用（第三者への開示及び公表も含みます。）することができるものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第12条（登録取消等）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>当社は、求職者が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該求職者について本サービスの利用を一時的に停止し、又は求職者としての登録を取り消すことができます。</li>
            <ol>
              <li>本規約のいずれかの条項に違反した場合</li>
              <li>登録情報、プロフィール情報又は連絡先に虚偽の事実があることが判明した場合</li>
              <li>当社、求人企業、他の求職者、外部事業者その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合</li>
              <li>外部利用規約に違反したことその他の理由によって、求職者が外部事業者から、そのサービスの提供や連携を受けられなくなった場合</li>
              <li>手段の如何を問わず、本サービスの運営を妨害した場合</li>
              <li>支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</li>
              <li>自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき</li>
              <li>差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</li>
              <li>租税公課の滞納処分を受けた場合</li>
              <li>求職者が死亡した場合</li>
              <li>6ヶ月以上本サービスの利用がなく、当社からの連絡に対して応答がない場合</li>
              <li>第3条第3項各号に該当する場合</li>
              <li>その他、当社が求職者としての登録の継続を適当でないと合理的に判断した場合</li>
            </ol>
            <li>求職者は、当社所定の方法で当社に通知することにより、当該通知をした日をもって求職者の登録を取り消すことができます。</li>
            <li>求職者が本サービスの登録を取り消し、又は取り消された場合、当社は、当該求職者に係るプロフィール情報、連絡先及び本サービス上でのメッセージの内容その他のデータを削除することができるものとします。</li>
            <li>当社は、本条に基づき当社が行った行為により求職者に生じた損害について一切の責任を負いません。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第13条（保証の否認及び免責）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>本サービスは現状有姿で提供されるものであり、当社は本サービスについて、特定の目的への適合性、商業的有用性、完全性、継続性、求人企業との雇用契約又は業務委託契約の締結をすることができることの確実性、求人情報その他の求人企業に関する情報の正確性及び完全性等を含め、一切保証を致しません。</li>
            <li>求職者が当社から直接又は間接に、本サービス、当社ウェブサイト、求人企業、本サービスの他の求職者その他の事項に関する何らかの情報を得た場合であっても、当社は求職者に対し本規約において規定されている内容を超えて如何なる保証も行うものではありません。</li>
            <li>本サービス上で開示されるプロフィール情報及び連絡先は、求職者が自らの責任で記入するものとし、当社はプロフィール情報及び連絡先の内容等について、一切責任を負いません。</li>
            <li>本サービスは、外部サービスと連携することがありますが、かかる連携を保証するものではなく、外部サービスとの連携の支障等について、当社の責に帰すべき場合を除き、当社は一切の責任を負いません。</li>
            <li>本サービスが外部サービスと連携している場合において、求職者は外部利用規約を自己の費用と責任で遵守するものとし、その違反によって求職者と当該外部サービスを運営する外部事業者との間で紛争等が生じた場合でも、当社は当該紛争等について一切の責任を負いません。</li>
            <li>求職者は、本サービスを利用することが、求職者に適用のある法令、法人その他の団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、求職者による本サービスの利用が、求職者に適用のある法令、法人その他の団体の内部規則等に適合することを何ら保証するものではありません。</li>
            <li>本サービス又は当社ウェブサイトに関連して求職者と求人企業、他の求職者、外部事業者その他の第三者との間において生じた取引、連絡、紛争等については、求職者の責任において処理及び解決するものとし、当社の責に帰すべき場合を除き、当社はかかる事項について一切責任を負いません。</li>
            <li>当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、求職者のプロフィール情報、連絡先、求人情報、メッセージその他の情報の削除又は消失､求職者の登録の取消、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連して求職者が被った損害につき、当社の責に帰すべき場合を除き、賠償する責任を一切負わないものとします。</li>
            <li>当社ウェブサイトから他のウェブサイトへのリンク又は他のウェブサイトから当社ウェブサイトへのリンクが提供されている場合でも、当社は、当社ウェブサイト以外のウェブサイト及びそこから得られる情報に関して、当社の責に帰すべき場合を除き、一切の責任を負わないものとします。</li>
            <li>当社は、当社の合理的な支配の及ばない状況（火事、停電、ハッキング、コンピューターウィルスの侵入、地震、洪水、戦争、疫病、通商停止、ストライキ、暴動、物資及び輸送施設の確保不能、政府当局若しくは地方自治体による介入、指示若しくは要請、又は内外法令の制定若しくは改廃を含みますがこれらに限定されません。）により利用契約上の義務を履行できない場合、その状態が継続する期間中求職者に対し債務不履行責任を負わないものとします。</li>
            <li>法令の適用その他何らかの理由により、当社が求職者に対して損害賠償責任を負う場合においても、当社に故意又は重過失がない限り当社の責任は直接かつ通常の損害に限られるものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第14条（求職者の賠償等の責任）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者は、本規約に違反することにより、又は本サービスの利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償しなければなりません。</li>
            <li>求職者が、本サービス（プロフィール情報及び連絡先の内容等を含みます。）に関連して求人企業、他の求職者、外部事業者その他の第三者から何らかの請求等を受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、求職者の費用と責任において当該請求等又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。</li>
            <li>求職者による本サービスの利用に関連して、当社が、求人企業、他の求職者、外部事業者その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合は、求職者は当該請求に基づき当社が当該第三者に支払を余儀なくされた金額を賠償しなければなりません。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第15条（秘密保持）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>本規約において「秘密情報」とは、利用契約又は本サービスに関連して、求職者が、当社より書面、口頭若しくは記録媒体等により提供若しくは開示されたか、又は知り得た、当社の技術、営業、業務、財務、組織、その他の事項に関する全ての情報を意味します。但し、(1)当社から提供若しくは開示がなされたとき又は知得したときに、既に一般に公知となっていた、又は既に知得していたもの、(2)当社から提供若しくは開示又は知得した後、自己の責めに帰せざる事由により刊行物その他により公知となったもの、(3)提供又は開示の権限のある第三者から秘密保持義務を負わされることなく適法に取得したもの、(4)秘密情報によることなく単独で開発したもの、(5)当社から秘密保持の必要なき旨書面で確認されたものについては、秘密情報から除外するものとします。</li>
            <li>求職者は、秘密情報を本サービスの利用の目的のみに利用するとともに、当社の書面による承諾なしに第三者に当社の秘密情報を提供、開示又は漏洩しないものとします。</li>
            <li>第2項の定めに拘わらず、当社及び求職者は、法律、裁判所又は政府機関の命令、要求又は要請に基づき、秘密情報を開示することができます。但し、当該命令、要求又は要請があった場合、速やかにその旨を当社に通知しなければなりません。</li>
            <li>求職者は、秘密情報を記載した文書又は磁気記録媒体等を複製する場合には、事前に当社の書面による承諾を得ることとし、複製物の管理については第2項に準じて厳重に行うものとします。</li>
            <li>求職者は、当社から求められた場合にはいつでも、遅滞なく、当社の指示に従い、秘密情報並びに秘密情報を記載又は包含した書面その他の記録媒体物及びその全ての複製物を返却又は廃棄しなければなりません。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第16条（個人情報の第三者への提供に対する同意）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          当社は、本サービスにおいて、以下の場合に求職者の個人情報を第三者に提供し、求職者はこれに同意するものとします。
          <ol>
            <li>求職者が応募した求人情報を掲載した求人企業又は求職者を雇用若しくは求職者に業務委託することを希望する求人企業に対して、プロフィール情報及び連絡先を提供する場合</li>
            <li>求職者のスカウトの為に、求人企業に対して、性別・学歴・年齢・スキル・経験・職務経歴等の情報を提供する場合</li>
            <li>転職祝い金等お支払の為に、金融機関に対して、氏名・振込先口座情報などを提供する場合</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第17条（転職祝い金）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者が本サービス上の求人広告に応募し、当該求人広告に係る求人企業に採用された場合、当社は、求職者の転職祝い金申請後、入社及び勤務継続（求職者、求人企業双方に対し、入社日より当社の定める期間を超えての勤務継続確認が出来ること）の事実確認等、別途当社が定める支払条件（以下、「支払条件」といいます）を充たしているかを確認できた場合に、転職祝い金をお支払いすることがあります。但し、申請期限内に申請がない場合や当社で定める支払条件を充たすことが確認できない場合には、転職祝い金は支払われません。</li>
            <li>転職祝い金の申請期限は、求職者が本サービス上の求人広告（採用企業のもの）に応募し、当該求人企業に採用され入社した日（入社日）から30日以内とします。申請期限内に当社へ申請を行わなかった場合は、転職祝い金の受取りを希望しないものとみなし、それ以降の申請は無効とします。</li>
            <li>前二項に定めるほか、第8条所定の禁止行為等、本規約違反があった場合、その他利用契約が終了した場合（本サービスの退会を含む）、求職者は、その時点で、転職祝い金を受け取る権利（事実確認中のもの、支払いが予定されているもの等、支払条件の充足状況を問いません）を喪失するものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第18条（メッセージの閲覧）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          求職者は、本サービス上での求人企業との間のメール又はメッセージのやりとりについて、本サービス上でのトラブルの防止及び対処その他の正当な目的がある場合には、当社が当該メール及び当該メッセージのやりとりを閲覧することができることについて、予め同意するものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第19条（アンケート等の実施）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          当社は、求職者が本サービス会員時または本サービス会員でなくなった後に、応募状況、内定状況、転職状況を含む本システムおよびその利用に関するアンケート等を実施することがあります。<br>
          求職者は、前項の場合に、自らの責任に基づいて情報や意見等を提供するものとし、自己の提供する情報や意見等については、当社に対し真実性、正確性を保証するものとします。<br>
          当社は、前項のアンケート等の結果につき、求職者の事前の承諾なくして自由に利用ないし利用許諾できるものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第20条（有効期間）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          利用契約は、求職者について第3条に基づく登録が完了した日に効力を生じ、当該求職者の登録が取り消された日又は本サービスの提供が終了した日のいずれか早い日まで、当社と求職者との間で有効に存続するものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第21条（本規約等の変更）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>当社は、本サービスの内容を自由に変更できるものとします。</li>
            <li>当社は、本規約（当社ウェブサイトに掲載する本サービスに関するルール、諸規定等を含みます。以下本項において同じ。）を変更できるものとします。当社は、本規約を変更する場合には、変更の内容及び変更の効力発生時期を、当該効力発生時期までに当社所定の方法で告知するものとします。告知された効力発生時期以降に求職者が本サービスを利用した場合又は当社の定める期間内に登録取消の手続をとらなかった場合には、求職者は、本規約の変更に同意したものとみなします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第22条（連絡/通知）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本サービスに関する問い合わせその他求職者から当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社から求職者に対する連絡又は通知は、当社の定める方法で行うものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第23条（本規約の譲渡等）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <ol>
            <li>求職者は、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
            <li>当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに求職者の登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、求職者は、かかる譲渡につき本項において予め同意したものとします。</li>
          </ol>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第24条（完全合意）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本規約は、本規約に含まれる事項に関する当社と求職者との完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する当社と求職者との事前の合意、表明及び了解に優先します。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第25条（分離可能性）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及び求職者は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第26条（存続規定）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          第6条第2項、第8条第2項、第9条第3項、第10条、第11条、第12条第2項から第4項まで、第13条から第15条まで、第18条、並びに第23条から第27条までの規定は利用契約の終了後も有効に存続するものとします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第27条（準拠法及び管轄裁判所）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4>第28条（協議解決）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          当社及び求職者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。
        </v-col>
      </v-row>
      <v-row justify="end" class="py-4">
        2021年1月22日改定<br>
        2020年8月17日制定
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "JobServiceTerms",
    props: {
      "isPage": {
        type: Boolean,
        default: false
      }
    },
    computed: {
      style(){
        if (this.isPage) {
          return "padding: 36px; margin: 20px;";
        }
        return "max-height: 160px; overflow-y: auto; font-size: 0.7rem;";
      },
      classes () {
        if(this.isPage) {
          return ""
        }
        return "px-3"
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
